import { render, staticRenderFns } from "./default-tags-listing.vue?vue&type=template&id=01d197f7&scoped=true&"
import script from "./default-tags-listing.vue?vue&type=script&lang=js&"
export * from "./default-tags-listing.vue?vue&type=script&lang=js&"
import style0 from "./default-tags-listing.vue?vue&type=style&index=0&id=01d197f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d197f7",
  null
  
)

export default component.exports